import { render, staticRenderFns } from "./leftPage.vue?vue&type=template&id=348614b0&scoped=true"
import script from "./leftPage.vue?vue&type=script&lang=js"
export * from "./leftPage.vue?vue&type=script&lang=js"
import style0 from "./leftPage.vue?vue&type=style&index=0&id=348614b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348614b0",
  null
  
)

export default component.exports